import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import { hooks } from '../../../config/api';
import generatePlanOptionsRollbar from '../../utils/generatePlanOptionsRollbar';
export var useSocialInsurancePlanOptions = function useSocialInsurancePlanOptions(_ref) {
  var providerId = _ref.providerId,
    networkId = _ref.networkId,
    contactId = _ref.contactId,
    _ref$hasEnrollments = _ref.hasEnrollments,
    hasEnrollments = _ref$hasEnrollments === void 0 ? false : _ref$hasEnrollments;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    planOptions = _useState2[0],
    setPlanOptions = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    name = _useState4[0],
    setName = _useState4[1];
  var _hooks$useFind = hooks.useFind('plan', {
      plan_type: 'social',
      state: 'active',
      name: name,
      provider: providerId,
      enrollment_required: hasEnrollments ? undefined : false
    }, {
      page: {
        size: Infinity
      },
      queryConfig: {
        refetchOnWindowFocus: false,
        onError: function onError(error) {
          if (window.Rollbar) generatePlanOptionsRollbar({
            response: error,
            contactId: contactId
          });
          setPlanOptions([]);
        },
        enabled: !!providerId,
        placeholderData: undefined
      }
    }),
    providerPlansData = _hooks$useFind.data,
    isProvidersPlanLoading = _hooks$useFind.isLoading,
    isProvidersPlanSuccess = _hooks$useFind.isSuccess;
  var _hooks$useFind2 = hooks.useFind('plan', {
      plan_type: 'social',
      state: 'active',
      name: name,
      network: networkId,
      enrollment_required: hasEnrollments ? undefined : false
    }, {
      page: {
        size: Infinity
      },
      queryConfig: {
        refetchOnWindowFocus: false,
        onError: function onError(error) {
          if (window.Rollbar) generatePlanOptionsRollbar({
            response: error,
            contactId: contactId
          });
          setPlanOptions([]);
        },
        enabled: !!networkId && isProvidersPlanSuccess && !(providerPlansData !== null && providerPlansData !== void 0 && providerPlansData.data.data.length),
        placeholderData: undefined
      }
    }),
    networkPlansData = _hooks$useFind2.data,
    isNetworkPlansLoading = _hooks$useFind2.isLoading,
    isNetworkPlansSuccess = _hooks$useFind2.isSuccess;
  var isSuccess = isNetworkPlansSuccess || isProvidersPlanSuccess;
  var isLoading = isNetworkPlansLoading || isProvidersPlanLoading;
  useEffect(function () {
    if (isSuccess && !isLoading) {
      var data = providerPlansData !== null && providerPlansData !== void 0 && providerPlansData.data.data.length ? providerPlansData === null || providerPlansData === void 0 ? void 0 : providerPlansData.data.data : networkPlansData === null || networkPlansData === void 0 ? void 0 : networkPlansData.data.data;
      setPlanOptions(data !== null && data !== void 0 ? data : []);
    }
  }, [networkPlansData, providerPlansData, isSuccess, isLoading, setPlanOptions]);
  var loadPlanOptions = function loadPlanOptions(search) {
    setName(search);
  };
  return {
    planOptions: planOptions,
    loadPlanOptions: loadPlanOptions
  };
};
//# sourceMappingURL=useSocialInsurancePlanOptions.js.map